import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/core/Home.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/Appointment',
      name: 'Appointment',
      component: () => import('./views/entities/Appointment.vue'),
    },
  ],
});